<template>
  <div class="preview-container">
    <div class="top-image-box">
      <a-carousel v-if="menuInfo.image && menuInfo.image.length > 1" ref="topImage" autoplay>
        <img class="top-image" v-for="item in menuInfo.image" :key="item._id" :src="$Dolphin.path.publicPath + item.filePath">
      </a-carousel>
      <img class="top-image" v-else :src="topImageSrc">
      <div class="top-mask">
        <template v-if="menuInfo.image && menuInfo.image.length > 1">
          <div class="image-button image-button_left" @click="$refs.topImage.prev()">
            <dol-icon type="LeftOutlined" />
          </div>
          <div class="image-button image-button_right" @click="$refs.topImage.next()">
            <dol-icon type="RightOutlined" />
          </div>
        </template>
      </div>
      <div class="top-text">
        <div class="main-title">{{ $dt(menuInfo, 'name') }}</div>
        <div class="sub-title">{{ menuInfo.parent ? $dt(menuInfo.parent, 'name') + ' / ' : '' }}{{ $dt(menuInfo, 'name') }}</div>
      </div>
    </div>
    <template v-for="item in configList">
      <template v-if="item.type !== 'special'">
        <component :is="item.type" :eleConfig="item" />
      </template>
    </template>
    <sign-bar v-if="menuInfo.signFlag" :menu-info="menuInfo" />
  </div>
</template>
<script>
import defaultTopImage from '../../../public/static/customPage/defaultTop.png'
import ImgAndContent from '../showComponents/imgAndContent.vue';
import ImgAndContentFullWidth from '../showComponents/imgAndContentFullWidth.vue';
import BlockArr from '../showComponents/blockArr.vue';
import ImageOnly from '../showComponents/imageOnly.vue';
import LikeNews from '../showComponents/likeNews.vue';
import TitleContentBlock from '../showComponents/titleContentBlock.vue';
import SpecialA from '../showComponents/specialA.vue';
import SpecialB from '../showComponents/specialB.vue';
import SpecialC from '../showComponents/specialC.vue';
import SpecialD from '../showComponents/specialD.vue';
import SpecialE from '../showComponents/specialE.vue';
import SpecialF from '../showComponents/specialF.vue';
import SpecialG from '../showComponents/specialG.vue';
import SpecialH from '../showComponents/specialH.vue';
import SignBar from '@/views/subPage/signBar.vue';

export default {
  name: "previewPage",
  components: {
    SignBar,
    SpecialH,
    SpecialG,
    SpecialF,
    SpecialE,
    SpecialD,
    SpecialC,
    SpecialB,
    SpecialA,
    TitleContentBlock,
    LikeNews,
    ImageOnly,
    BlockArr,
    ImgAndContentFullWidth,
    ImgAndContent
  },
  data() {
    return {
      menuInfo: {},
      configList: [],
    }
  },
  computed: {
    topImageSrc() {
      const image = this.menuInfo.image?.[0]
      return image?.filePath ? this.$Dolphin.path.publicPath + image.filePath : defaultTopImage
    }
  },
  watch: {
    $route(to, from) {
      const id = to.path.split('/').pop();
      this.query(id);
    }
  },
  methods: {
    query(id) {
      this.$ajax({
        url: '/portal/queryPage',
        params: { id },
      }).then(({ data, rows }) => {
        this.menuInfo = data;
        this.configList = rows;
      })
    },
  },
  created() {
    // console.log(this.$route)
    const id = this.$route.path.split('/').pop();
    this.query(id);
  },
  mounted() {
  },
  beforeUnmount() {
  },
}
</script>

<style scoped lang="scss">
.preview-container {
  width: 100%;
  font-family: "alph";
}

.top-image-box {
  position: relative;
  width: 100%;
  min-height: 300px;

  .top-image {
    width: 100%;
  }

  img {
    width: 100%;
    display: block;
    height: auto;
  }

  .top-mask {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.3);

    .image-button {
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
      background-color: rgba(255, 255, 255, 0.5);

      &_left {
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
      }

      &_right {
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .top-text {
    position: absolute;
    bottom: 100px;
    left: 0;
    right: 0;
    text-align: center;
    color: #fff;

    .main-title {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 24px;
    }

    .sub-title {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>
